import { mapActions } from 'vuex'
import { cloneDeep, get, isEmpty } from 'lodash'
import EventBus from './event-bus'
import { IMAGE_TYPES } from '../utils'

export default {
  data() {
    return {
      files: [],
      oldFile: {},
      fileId: null,
      uploadProgress: {},
      componentRefresh: 0,
      hasDragEntered: false,
      modalId: `cameras-confirm-${this.path}`,
    }
  },
  computed: {
    acceptTypes() {
      return `${this.accept};capture=camera`
    },
  },
  methods: {
    ...mapActions(['showModal']),
    onDragEnter() {
      this.hasDragEntered = true
    },
    onDragLeave() {
      this.hasDragEntered = false
    },
    onDrop() {
      this.hasDragEntered = false
    },
    onChange($event) {
      const files = get($event, 'target.files', [])
      if (!isEmpty(files)) {
        Array.from(files).forEach(this.processFile)
      }
    },
    onConfirm(confirm) {
      if (confirm) {
        this.onRemove()
      }
      this.fileId = null
    },
    onRemove() {
      if (!this.fileId || !this.$refs.input) return
      this.$refs.input.value = null

      if (!this.files || !Array.isArray(this.files)) return
      this.files = this.files.filter((file) => file.key !== this.fileId)
    },
    confirmRemove(key) {
      if (!this.computedReadOnly) {
        this.showModal({ id: this.modalId, params: {} })
        EventBus.$emit('removeSticky')
        this.fileId = key
      }
    },
    checkMimeType(type = '') {
      type = type.toLowerCase()
      const mimes = cloneDeep(this.mimeTypes()) || []
      if (mimes.includes('application/zip')) {
        // régebbi formok esetében kell, ahol nem lett rámentve a formra a zip-es javítás óta
        mimes.push('application/x-zip-compressed')
      }
      if (isEmpty(mimes)) return true
      return mimes.find((mime) => mime === type)
    },
    checkType(fileName = '') {
      fileName = fileName.toLowerCase()
      const fileTypes = this.fileTypes()
      if (!fileTypes || isEmpty(fileTypes)) return true
      const type = fileName.split('.')
      return fileTypes.includes(type[type.length - 1])
    },
    checkFile(path, isStatic) {
      return this.$client.execute({
        operationId: 'DocumentStorage_checkFile',
        parameters: {
          path,
          isStatic: !!isStatic,
        },
      })
    },
    checkFiles(files) {
      return Promise.all(
        files.map((file) => {
          file.key = file.id
          file.loading = true

          return this.checkFile(file.path, file.isStatic).then((response) => {
            const isValid = get(response, 'body.valid', false)

            if (!isValid) file.error = 'invald file'
            file.checked = true
            file.loading = false

            return file
          })
        }),
      )
    },
    findDocuments(filter) {
      return this.$client.execute({
        operationId: 'DocumentStorage_find',
        parameters: { filter },
      })
    },
    fileTypes() {
      return get(this.field, 'formats.fileTypes', [])
    },
    isFileValid(file) {
      const acceptedExtensions = get(this.field, 'acceptedExtensions')
      const maxSize = this.maxFileSize() || this.maxSize
      const noty = { type: 'error' }

      let isValid = true
      if (file.type && !this.checkMimeType(file.type)) {
        noty.text = 'cameras_file_mimeError ${extensions}'
        noty.params = { extensions: acceptedExtensions }
        this.showNotification(noty)
        isValid = false
      } else if (!this.checkType(file.name)) {
        noty.text = 'cameras_file_mimeError ${extensions}'
        noty.params = { extensions: acceptedExtensions }
        this.showNotification(noty)
        isValid = false
      }

      if (maxSize && file.size >= maxSize) {
        noty.text = 'cameras_file_sizeError ${size}'
        noty.params = { size: maxSize }
        this.showNotification(noty)
        isValid = false
      }

      return isValid
    },
    isImageType(type) {
      return IMAGE_TYPES.includes(type)
    },
    maxFileSize() {
      return get(this.field, 'maxFileSizeInteger')
    },
    mimeTypes() {
      return get(this.field, 'mimeTypes')
    },
    renameFile(originalFile, newName) {
      return new File([originalFile], newName, {
        type: originalFile.type,
        lastModified: originalFile.lastModified,
      })
    },
    changeFile(file) {
      if (!this.computedReadOnly && this.$refs.input) {
        this.$refs.input.click()
        this.oldFile = file
      }
    },
    getAxiosConfig(file) {
      return {
        headers: { 'Content-Type': 'multipart/form-data' },
        onUploadProgress: (progressEvent) => {
          const progress = Math.round((progressEvent.loaded * 100) / progressEvent.total) - 1
          const finished = progressEvent.loaded === progressEvent.total
          this.$set(this.uploadProgress, file.key, { progress, finished })
          if (finished) {
            this.$delete(this.uploadProgress, file.key)
          }
        },
      }
    },
    getImageSize(data) {
      return new Promise((resolve, reject) => {
        const img = new Image()
        img.onload = () => resolve(img)
        img.onerror = reject
        img.src = URL.createObjectURL(data)
      })
    },
    shortFilename(name) {
      const length = 15
      return name.length > length ? name.substring(0, length) + '...' : name
    },
  },
}